import { ChangeDetectionStrategy, Component, Injector } from '@angular/core';
import { isDefined, isFalsy } from '@sama/js-core';
import { Observable, switchMap } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { outputAnnotationInfoStoreToken } from '../../../../../../outputs/annotation/annotation-shared/annotation-providers';

@Component({
  selector: 'h3-frame-loading-bar',
  templateUrl: './frame-loading-bar.component.html',
  styleUrls: ['./frame-loading-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FrameLoadingBarComponent {
  showLoadingBar$: Observable<boolean>;
  loadedFrames$: Observable<boolean[]>;

  constructor(injector: Injector) {
    const sensorRendererStore = injector.get(outputAnnotationInfoStoreToken)(
      'sensorRendererState',
    );

    const loadedFramesStore$ = sensorRendererStore.$.pipe(
      filter(isDefined),
      switchMap(() => sensorRendererStore('loadedFrames').$),
      filter(isDefined),
    );
    this.loadedFrames$ = loadedFramesStore$.pipe(
      map((loadedFrames: boolean[]) => loadedFrames.slice(0, -1)),
    );
    this.showLoadingBar$ = loadedFramesStore$.pipe(
      map((frameIsLoaded: boolean[]) => frameIsLoaded.some(isFalsy)),
    );
  }

  trackByIndex = (index: number) => index;
}
